module.exports = __webpack_public_path__ + "static/media/secreativo_mobile.22cbc644.svg";